import { Container } from '@mui/material';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import Page from '../../../components/Page';
import { useParams } from 'react-router-dom';
import FlavorForm from './FlavorForm';

const index = () => {
  const params: any = useParams();
  const isAddMode = !params?.id;
  return (
    <Page title={'Flavor'}>
      <Container maxWidth={'xl'}>
        <HeaderBreadcrumbs
          heading={`${isAddMode ? 'Add Flavor' : 'Edit Flavor'} `}
          links={[
            { name: 'Dashboard', href: '/' },
            { name: 'Flavor', href: '/flavor' },
          ]}
        />
        <FlavorForm />
      </Container>
    </Page>
  );
};

export default index;
